import { escapeHtml as esc } from './escapeHtml.js';
import { mlvApplyZ } from './mlvZLayers.js';
import { mlvSaveFocus } from './mlvFocusRestore.js';
import { mlvModalHistoryAttach } from '../navigation/mlvModalHistoryBridge.js';

/** @returns {Promise<string|null>} motivo o null si canceló */
export function openAdminEliminarPublicacionModal({ tituloProducto = '' } = {}) {
  return new Promise((resolve) => {
    const restoreFocus = mlvSaveFocus();
    const prev = document.getElementById('mlv-admin-del-pub-modal');
    if (prev) prev.remove();
    const wrap = document.createElement('div');
    wrap.id = 'mlv-admin-del-pub-modal';
    wrap.className =
      'fixed inset-0 flex items-end justify-center bg-black/55 p-4 sm:items-center';
    mlvApplyZ(wrap, 'compradorTag');
    const tit = String(tituloProducto || '').trim();
    wrap.innerHTML = `
      <div class="w-full max-w-md rounded-t-3xl bg-white p-5 shadow-2xl ring-1 ring-slate-200/80 sm:rounded-3xl">
        <h3 class="font-heading text-lg font-bold text-slate-900">Borrar publicación</h3>
        ${
          tit
            ? `<p class="mt-2 text-sm text-slate-600">«<strong class="font-semibold text-slate-800">${esc(tit)}</strong>»</p>`
            : ''
        }
        <p class="mt-2 text-sm leading-relaxed text-slate-600">
          El vendedor recibirá este mensaje en sus notificaciones. La publicación se elimina por completo.
        </p>
        <label class="mt-3 block text-xs font-medium text-slate-600" for="mlv-admin-del-motivo">Motivo para el vendedor</label>
        <textarea id="mlv-admin-del-motivo" rows="4" class="mt-1 w-full resize-y rounded-xl border border-slate-300 px-3 py-2.5 text-sm text-slate-900 focus:outline-none focus:ring-2 focus:ring-brand-primary/30" placeholder="Explicá por qué se elimina…"></textarea>
        <div class="mt-5 flex gap-2">
          <button type="button" id="mlv-admin-del-cancel" class="flex-1 rounded-full border border-slate-300 bg-white py-2.5 text-sm font-semibold text-slate-700">Cancelar</button>
          <button type="button" id="mlv-admin-del-ok" class="flex-1 rounded-full bg-red-600 py-2.5 text-sm font-semibold text-white hover:brightness-95">Confirmar borrado</button>
        </div>
      </div>
    `;
    let pending = null;
    const hist = mlvModalHistoryAttach(() => {
      document.removeEventListener('keydown', onKey);
      try {
        restoreFocus();
      } catch (_e) {
        /* ignore */
      }
      wrap.remove();
      resolve(pending);
    });
    function closeWith(v) {
      pending = v;
      hist.closeFromUi();
    }
    function onKey(e) {
      if (e.key === 'Escape') closeWith(null);
    }
    wrap.addEventListener('click', (e) => {
      if (e.target === wrap) closeWith(null);
    });
    document.addEventListener('keydown', onKey);
    document.body.appendChild(wrap);
    const ta = wrap.querySelector('#mlv-admin-del-motivo');
    wrap.querySelector('#mlv-admin-del-cancel')?.addEventListener('click', () => closeWith(null));
    wrap.querySelector('#mlv-admin-del-ok')?.addEventListener('click', () => {
      const motivo = String(ta?.value || '').trim();
      if (!motivo) {
        ta?.focus();
        return;
      }
      closeWith(motivo);
    });
    ta?.focus();
  });
}
